// ============================================================================
// cattle.dailys.index — migrated off App-owned render reads
// ============================================================================
// The hub owns its full-history pages, edit-form input list, and visible saved
// view picker through scoped catalog resources. Its successful daily writes
// reconcile only the bounded Home recent-data context; saved-view writes use
// the picker's local resource refetch. Neither path retains an App data prop or
// captures the global daily refresh function. Recently Deleted keeps its
// independent action-time wildcard recovery path outside this surface; cattle
// itself refreshes through the domain-owned full-row recent-data boundary.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'cattle.dailys.index',
  obligations: Object.freeze([
    Object.freeze({id: 'cattle.dailys.list', owner: 'permanent'}),
    Object.freeze({id: 'cattle.dailys.formInputs', owner: 'permanent'}),
    Object.freeze({id: 'cattle.dailys.savedViews', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
